export const REWARD_REDEMPTION_LIST_REQUEST = "REWARD_REDEMPTION_LIST_REQUEST";
export const REWARD_REDEMPTION_LIST_SUCCESS =
  "REWARD_REDEMPTION_LIST_REQUEST_SUCCESS";
export const REWARD_REDEMPTION_DETAIL_REQUEST =
  "REWARD_REDEMPTION_DETAIL_REQUEST";
export const REWARD_REDEMPTION_APPROVE_REQUEST =
  "REWARD_REDEMPTION_APPROVE_REQUEST";
export const REWARD_REDEMPTION_REJECT_REQUEST =
  "REWARD_REDEMPTION_REJECT_REQUEST";
export const REWARD_REDEMPTION_COMPLETE_REQUEST =
  "REWARD_REDEMPTION_COMPLETE_REQUEST";

export const READ_REWARD_REDEMPTION = 277000;
export const APPROVE_REWARD_REDEMPTION = 277010;
export const REJECT_REWARD_REDEMPTION = 277011;
export const COMPLETE_REWARD_REDEMPTION = 277012;

export const REWARD_REDEMPTION_STATUS_REQUESTED = 1;
export const REWARD_REDEMPTION_STATUS_APPROVED = 2;
export const REWARD_REDEMPTION_STATUS_COMPLETED = 3;
export const REWARD_REDEMPTION_STATUS_REJECTED = 4;

export const REWARD_REDEMPTION_STATUS_REQUESTED_TITLE = "Requested";
export const REWARD_REDEMPTION_STATUS_APPROVED_TITLE = "Approved";
export const REWARD_REDEMPTION_STATUS_COMPLETED_TITLE = "Completed";
export const REWARD_REDEMPTION_STATUS_REJECTED_TITLE = "Rejected";

export const REWARD_REDEMPTION_STATUS_DATA_SOURCE = [
  {
    id: REWARD_REDEMPTION_STATUS_REQUESTED,
    name: REWARD_REDEMPTION_STATUS_REQUESTED_TITLE
  },
  {
    id: REWARD_REDEMPTION_STATUS_APPROVED,
    name: REWARD_REDEMPTION_STATUS_APPROVED_TITLE
  },
  {
    id: REWARD_REDEMPTION_STATUS_COMPLETED,
    name: REWARD_REDEMPTION_STATUS_COMPLETED_TITLE
  },
  {
    id: REWARD_REDEMPTION_STATUS_REJECTED,
    name: REWARD_REDEMPTION_STATUS_REJECTED_TITLE
  }
];